import React from 'react';
import { Icon } from '@workboard/action-item';
import {
  getAiTypeAttributes,
  getStateComponentIcon,
  getStateObjectLabel,
} from '../../../board/utils';
import { KeyDownEvent } from '../../../utils/eventKey'

const prepareOwnerDisplayName = (firstname, lastname, name = '') => {
  let ownerDisplayName = '';
  if (typeof firstname !== 'undefined') {
    const ownerFirstname = firstname.toLowerCase();
    ownerDisplayName = ownerFirstname.charAt(0).toUpperCase()
      + ownerFirstname.substr(1, ownerFirstname.length);
    if (typeof lastname !== 'undefined' && lastname.charAt(0) !== 'undefined' && lastname.charAt(0) != null) {
      ownerDisplayName += ` ${lastname.charAt(0).toUpperCase()}`;
    }
  } else {
    ownerDisplayName = name;
  }
  return ownerDisplayName;
}

const ActionItemRow = (props) => {
  const { ai, events, selectedItems = [] } = props;
  const aiDueDate = ai.due_date > 0 ? moment.utc(ai.due_date * 1000).format('MMM DD, YYYY') : '';
  const ownerDisplayName = (window.wbConfig.isNewMeetingsEnabled && ai.user)
    ? prepareOwnerDisplayName(ai.user.firstName, ai.user.lastName)
    : prepareOwnerDisplayName(ai.firstname, ai.lastname, ai.ownerName);
  const tagName = (window.wbConfig.isNewMeetingsEnabled && ai.tag) ? ai.tag.name : ai.tagName;
  const tagId = (window.wbConfig.isNewMeetingsEnabled && ai.tag) ? ai.tag.id : ai.tagId;
  const aiCheckBoxClassName = `chkbox aiCheckBox${window.wbConfig.isNewMeetingsEnabled && !tagName && !ownerDisplayName ? ' meetings' : ''}`;
  const { attributes, icons, label } = getAiTypeAttributes(ai.type ?? 0);
  const stateIconName = getStateComponentIcon(
    attributes?.state?.values ?? [],
    ai.state
  );
  const ragIconName = getStateComponentIcon(
    attributes?.rag?.values ?? [],
    ai.rag
  );

  const stateLabel = getStateObjectLabel(
    attributes?.state?.values ?? [],
    ai.state
  );
  const ragLabel = getStateObjectLabel(attributes?.rag?.values ?? [], ai.rag);
  return (
    <div className="wbActRowDiv" activity-id={ai.id} tag-id={tagId}>
      <div className={`rectbox-row WbActRow-${ai.id}`}>
        <div className="rectbox-col">
          <div className={aiCheckBoxClassName}>
            {/* <input type="checkbox" className="css-checkbox" checked={selectedItems.includes(ai.id)} value={ai.id} name="items[]" onChange={e => events.toggleChkBox(e, ai)} id={`item-chk-${ai.id}`} /> */}
            <span
              id={`item-chk-${ai.id}`}
              className={selectedItems.includes(ai.id) ? 'checkbox-icon-checked' : 'checkbox-icon-not-checked'}
              role="checkbox"
              value={ai.id}
              aria-checked={selectedItems.includes(ai.id)}
              aria-labelledby={`add-ai-chkbox-${ai.id} rect-box-subtitle-${ai.id} date-align-${ai.id}`}
              style={{ cursor: 'pointer' }}
              onClick={e => events.toggleChkBox(e, ai)}
              onKeyDown={(e) => {
                KeyDownEvent(e, () => events.toggleChkBox(e, ai), false, true)
              }}
              tabIndex="0"
            />
            <label className="css-label modalParaText" htmlFor={`item-chk-${ai.id}`} />
          </div>
        </div>
        <div className="rectbox-col">
          <div
            className="Cell alignCenter"
            role="img"
            aria-label={label}
          >
            <Icon name={icons?.component} width="15" height="15" />
          </div>
        </div>
        <div className="rectbox-col rectbox-col-goal rectbox-col-line">
          <div className="rectbox-title"  data-testid="rectbox-title" id={`add-ai-chkbox-${ai.id}`}>
            <span>
              {(window.wbConfig.isNewMeetingsEnabled && ai.name) ? ai.name : ai.description}
            </span>
            <label className="css-label modalParaText" htmlFor={`add-ai-chkbox-${ai.id}`} />

          </div>
          <div className="rectbox-subtitle" id={`rect-box-subtitle-${ai.id}`}>
            {tagName}
            {tagName && ownerDisplayName && <span className="dotClass" />}
            {ownerDisplayName}
          </div>
        </div>
        <div className="rectbox-col rectbox-col-last" id={`date-align-${ai.id}`}>
          <div className="aiStatusAlign">
            <div
              className="Cell width10 wbStatus wbStatusWidth alignCenter"
              role="img"
              aria-label={`Issue in ${stateLabel} ${
                attributes?.state?.label ?? 'Status'
              }`}
            >
              <Icon name={stateIconName} width="15" height="15" />
            </div>
            <div
              className="Cell width10 wsRag wbStatusWidth alignCenter"
              role="img"
              aria-label={`${ragLabel} ${
                attributes?.rag?.label ?? 'Confidence Rating'
              }`}
            >
              <Icon name={ragIconName} width="15" height="15" />
            </div>
          </div>
          <div className="aiDateAlign">
            {aiDueDate}
          </div>
        </div>
      </div>
    </div>
  );
};

export default ActionItemRow;
